









































import {Component, Prop, PropSync} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Options} from "@/plugins/print/lib/print";
import {getPublicPath} from "@/shared/services/helper/utils";
import PLDeliveryPrint from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliveryPrint/index.vue";
import {PickingListDeliveryStore} from "@/modules/pickinglistdeliveries";
import PLDeliveryExcel from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliveryExcel/index.vue";
import LadingPrintBill from "@/modules/ladings/Print/Bill/index.vue";
import PrintLading from "@/modules/ladings/Print/index.vue";
import {Lading} from "@/interfaces/entity";
import TableToExcel from "@linways/table-to-excel";

@Component({
    name: "PLDeliveryDetail",
    components: {PrintLading, LadingPrintBill, PLDeliveryExcel, PLDeliveryPrint}
})
export default class extends mixins(CommonMixin) {
    @PropSync("visible", {type: Boolean, default: false}) syncedVisible!: boolean;
    @Prop({type: Number, required: true}) readonly id!: number;

    printPickingListObj: Options = {
        id: 'print-picking-list-delivery',
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`
    };

    printBillLadingObj: Options = {
        id: 'print-bill-ladings',
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`
    };

    get billLadingIds() {
        return this.getProp(this.pickingListDelivery, 'billLadings', []).map((billLading: Lading) => billLading.rowGuid);
    }

    get pickingListDelivery() {
        return PickingListDeliveryStore.data[this.id];
    }

    closeModal() {
        this.syncedVisible = false;
    }

    printPickingList() {
        this.$print(this.printPickingListObj);
    }

    printBillLading() {
        this.$print(this.printBillLadingObj);
    }

    exportExcel() {
        TableToExcel.convert(document.getElementById("table-excel-pl-delivery"), {
            name: `Bảng kê phân công phát.xlsx`,
            sheet: {
                name: "Sheet 1"
            }
        });
    }
}
